export default __webpack_public_path__ + "images/6c92ef5f6847b59e6596004df8bfb6c1-religious_music_small.webp";